import React, { useEffect, useState } from 'react'
import { Menu, Button, Dropdown } from 'antd'
import { 
  AppstoreOutlined, 
  UserOutlined, 
  DownOutlined, 
  LockOutlined,
  LogoutOutlined,
  ShoppingCartOutlined,
  ShoppingOutlined,
  TeamOutlined,
  FileTextOutlined,
  DeleteOutlined,
  SafetyOutlined,
  CheckSquareOutlined,
  SettingOutlined,
  DollarOutlined,
  InboxOutlined,
  BarChartOutlined,
  CoffeeOutlined,
  AlertOutlined
} from '@ant-design/icons'
import { getName, logout } from '../../services/lib/utils/auth.utils'
import { Link, useHistory, useLocation} from 'react-router-dom'
import './style.css'
import SweetAlertService from '../../services/lib/utils/sweet-alert-service'
import { ApiRequest } from '../../services/api/api'
import { getCookie } from 'react-use-cookie'
import Headroom from 'react-headroom'

const { SubMenu } = Menu

// Icon mapping for different menu types
const getMenuIcon = (groupName: string) => {
  const name = groupName.toLowerCase()
  
  if (name.includes('sale')) return <ShoppingCartOutlined style={{ fontSize: '16px' }} />
  if (name.includes('production')) return <CoffeeOutlined style={{ fontSize: '16px' }} />
  if (name.includes('warehouse') || name.includes('inventory')) return <InboxOutlined style={{ fontSize: '16px' }} />
  if (name.includes('purchase')) return <ShoppingOutlined style={{ fontSize: '16px' }} />
  if (name.includes('employee') || name.includes('staff')) return <TeamOutlined style={{ fontSize: '16px' }} />
  if (name.includes('report')) return <BarChartOutlined style={{ fontSize: '16px' }} />
  if (name.includes('delete') || name.includes('history')) return <DeleteOutlined style={{ fontSize: '16px' }} />
  if (name.includes('quality')) return <SafetyOutlined style={{ fontSize: '16px' }} />
  if (name.includes('task')) return <CheckSquareOutlined style={{ fontSize: '16px' }} />
  if (name.includes('setting')) return <SettingOutlined style={{ fontSize: '16px' }} />
  if (name.includes('finance') || name.includes('accounting')) return <DollarOutlined style={{ fontSize: '16px' }} />
  if (name.includes('maintenance')) return <AlertOutlined style={{ fontSize: '16px' }} />
  
  return <AppstoreOutlined style={{ fontSize: '16px' }} />
}

function CommonHeader() {
  const history = useHistory()
  const location = useLocation()
  const [current, setCurrent] = useState('mail')
  const [userRoutes, setUserRoutes] = useState<any>([])
  const [isMobile, setIsMobile] = useState(false)

  // 检测屏幕尺寸
  useEffect(() => {
    const checkScreenSize = () => {
      setIsMobile(window.innerWidth < 768)
    }
    
    checkScreenSize()
    window.addEventListener('resize', checkScreenSize)
    
    return () => {
      window.removeEventListener('resize', checkScreenSize)
    }
  }, [])

  useEffect(() => {
    let isCancelled = false
    let allRoutes: any = []
    const pages: any = localStorage.getItem('pages')
    console.log(JSON.parse(pages))
    const vfsFonts = import("pdfmake/build/vfs_fonts"); 
    
    const a = (JSON.parse(pages) || []).map((row: any) => {
      if (!allRoutes.filter((item: any) => item.groupId === row.groupId)[0]) {
        allRoutes.push({
          ...row,
          pages: [row]
        })
      } else {
        allRoutes = allRoutes.map((item: any) => item.groupId === row.groupId ? ({...item, pages: [...item.pages, row]}) : item)
      }
    })
    console.log(allRoutes)
    if (!isCancelled) {
      const userRouters = allRoutes.sort((a: any, b: any) => a.group.sortingOrder - b.group.sortingOrder).map((row: any) => ({
        title: row.group.groupName,
        drop: true,
        accessLevel: 1,
        icon: getMenuIcon(row.group.groupName),
        inter: row.pages.sort((a: any, b: any) => a.sortingOrder - b.sortingOrder).map((item: any) => ({
          title: item.pageName,
          path: item.pageUrl,
          accessLevel: 2,
        }))
      }))
      console.log(userRouters)
      setUserRoutes(userRouters)
    }
    return () => {
      isCancelled = true
    }
  }, [location.pathname, current])

  const onMenuClick = (item: any) => {
    setCurrent(item.key)
  }

  const profileMenu = (
    <Menu style={{ 
      borderRadius: '8px', 
      boxShadow: '0 4px 12px rgba(27, 59, 46, 0.15)',
      border: '1px solid #e8f5ed'
    }}>
      <Menu.Item 
        key="1" 
        icon={<LockOutlined style={{ color: '#1B3B2E' }} />} 
        style={{
          padding: '12px 16px',
          transition: 'all 0.3s ease'
        }}
        onClick={async () => {
          const result = await SweetAlertService.inputConfirm({
            type: 'text',
            title: 'New Password',
            defaultValue: '',
            placeholder: 'Enter new password'
          })
          if (result) {
            ApiRequest({
              url: 'Employee/ResetPassword?employeeId=' + getCookie('id') + '&newPassword=' + result,
              method: 'put'
            }).then(async _ => {
              await SweetAlertService.successMessage()
              logout(() => history.push('/'))
              sessionStorage.removeItem('token')
            })
          }
        }}
      >
        <span style={{ color: '#1B3B2E', fontWeight: 500 }}>Change Password</span>
      </Menu.Item>
      <Menu.Divider style={{ margin: '4px 0', backgroundColor: '#e8f5ed' }} />
      <Menu.Item 
        key="2" 
        icon={<LogoutOutlined style={{ color: '#1B3B2E' }} />} 
        style={{
          padding: '12px 16px',
          transition: 'all 0.3s ease'
        }}
        onClick={() => {
          logout(() => history.push('/'))
          sessionStorage.removeItem('token')
          localStorage.removeItem('USER_TYPE')
        }}
      >
        <span style={{ color: '#1B3B2E', fontWeight: 500 }}>Logout</span>
      </Menu.Item>
    </Menu>
  )

  return (
    <Headroom>
      <div style={{
        display: 'flex', 
        boxShadow: '0 2px 16px rgba(27, 59, 46, 0.12)', 
        height: '64px', 
        width: '100%', 
        position: 'sticky', 
        top: 0, 
        zIndex: 20, 
        background: 'linear-gradient(to right, #ffffff 0%, #f9fdfb 100%)',
        borderBottom: '2px solid #8BC9A3',
        // 添加响应式边距
        paddingLeft: isMobile ? '16px' : '0',
        paddingRight: isMobile ? '16px' : '0',
        boxSizing: 'border-box'
      }}>
        {/* Logo Section - 在小屏幕上缩小 */}
        <div style={{
          width: isMobile ? '160px' : '200px', 
          textAlign: 'center', 
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          backgroundColor: '#ffffff',
          borderRight: '1px solid #e8f5ed',
          cursor: 'pointer',
          transition: 'all 0.3s ease',
          position: 'relative',
          flexShrink: 0 // 防止缩小
        }} 
        onClick={() => history.push('/home')}
        onMouseEnter={(e) => {
          e.currentTarget.style.backgroundColor = '#f9fdfb'
          e.currentTarget.style.transform = 'scale(1.02)'
        }}
        onMouseLeave={(e) => {
          e.currentTarget.style.backgroundColor = '#ffffff'
          e.currentTarget.style.transform = 'scale(1)'
        }}
        >
          <img 
            src="https://jadcup.co.nz/wp-content/uploads/2023/03/logo-1.png" 
            style={{
              height: isMobile ? '32px' : '42px', 
              cursor: 'pointer',
              transition: 'all 0.3s ease',
              maxWidth: '100%'
            }} 
            alt="Jad Cup - Home"
            title="Go to Home"
          />
        </div>

        {/* Navigation Menu - 添加滚动支持 */}
        <div style={{
          flex: 1, 
          display: 'flex', 
          alignItems: 'center',
          overflow: isMobile ? 'auto' : 'hidden',
          msOverflowStyle: 'none',  // IE and Edge
          scrollbarWidth: 'none',   // Firefox
        }}>
          {/* Hide scrollbar for Chrome, Safari and Opera */}
          <style>
            {`
              .menu-container::-webkit-scrollbar {
                display: none;
              }
            `}
          </style>
          <Menu  
            triggerSubMenuAction={'click'}  
            mode="horizontal" 
            selectedKeys={[current]}
            style={{
              flex: 1,
              border: 'none',
              backgroundColor: 'transparent',
              lineHeight: '64px',
              minWidth: isMobile ? '600px' : '0', // 在小屏幕上确保菜单有足够宽度
              whiteSpace: 'nowrap'
            }}
            className="jadcup-menu"
            overflowedIndicator={isMobile ? <span>☰</span> : undefined}
          >
            {/* Dynamic Menu Items from Backend */}
            {userRoutes.map((item: any) => {
              if (item.drop) {
                return (
                  <SubMenu 
                    onTitleClick={onMenuClick} 
                    key={item.title} 
                    title={
                      <span style={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
                        {!isMobile && item.icon}
                        {item.title}
                      </span>
                    }
                    style={{
                      color: '#1B3B2E',
                      fontWeight: 500,
                      fontSize: isMobile ? '14px' : '15px'
                    }}
                  >
                    {item.inter.map((item2: any) => {
                      if (item2.path && item2.title) {
                        return (
                          <Menu.Item  
                            key={item2.title} 
                            style={{
                              color: '#1B3B2E',
                              // padding: '12px 20px',
                              transition: 'all 0.3s ease'
                            }}
                          >
                            <Link to={item2.path}>{item2.title}</Link>
                          </Menu.Item>
                        )
                      }
                    })}
                  </SubMenu>
                )
              }
              return null
            })}
          </Menu>
        </div>

        {/* User Profile Section - 在小屏幕上调整 */}
        <div style={{
          display: 'flex',
          alignItems: 'center',
          padding: isMobile ? '0 8px' : '0 20px',
          backgroundColor: '#ffffff',
          borderLeft: '1px solid #e8f5ed',
          flexShrink: 0 // 防止缩小
        }}>
          <Dropdown 
            overlay={profileMenu} 
            placement="bottomRight"
            trigger={['click']}
          >
            <Button 
              style={{
                color: '#1B3B2E',
                background: 'linear-gradient(135deg, #8BC9A3 0%, #6FB890 100%)',
                border: 'none',
                borderRadius: '8px',
                height: '40px',
                padding: isMobile ? '0 12px' : '0 20px',
                fontWeight: 600,
                fontSize: isMobile ? '12px' : '14px',
                display: 'flex',
                alignItems: 'center',
                gap: '6px',
                boxShadow: '0 2px 8px rgba(139, 201, 163, 0.3)',
                transition: 'all 0.3s ease',
                cursor: 'pointer',
                whiteSpace: 'nowrap'
              }}
              icon={!isMobile && <UserOutlined style={{ fontSize: '16px', color: '#ffffff' }} />}
              onMouseEnter={(e) => {
                e.currentTarget.style.transform = 'translateY(-2px)'
                e.currentTarget.style.boxShadow = '0 4px 12px rgba(139, 201, 163, 0.4)'
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.transform = 'translateY(0)'
                e.currentTarget.style.boxShadow = '0 2px 8px rgba(139, 201, 163, 0.3)'
              }}
            >
              <span style={{ color: '#ffffff' }}>
                {isMobile ? `Hi, ${getName().split(' ')[0]}` : `Hi, ${getName().split(' ')[0]}`}
              </span>
              <DownOutlined style={{ fontSize: '12px', color: '#ffffff' }} />
            </Button>
          </Dropdown>
        </div>
      </div>

      {/* Custom Styles */}
      <style>{`
        .jadcup-menu .ant-menu-item:hover,
        .jadcup-menu .ant-menu-submenu-title:hover {
          color: #8BC9A3 !important;
          background-color: rgba(139, 201, 163, 0.1) !important;
        }

        .jadcup-menu .ant-menu-item-selected {
          color: #8BC9A3 !important;
          border-bottom: 2px solid #8BC9A3 !important;
        }

        .jadcup-menu .ant-menu-submenu-selected > .ant-menu-submenu-title {
          color: #8BC9A3 !important;
          border-bottom: 2px solid #8BC9A3 !important;
        }

        .jadcup-menu .ant-menu-item a,
        .jadcup-menu .ant-menu-submenu-title {
          color: #1B3B2E;
          transition: all 0.3s ease;
        }

        .jadcup-menu .ant-menu-item:hover a {
          color: #8BC9A3 !important;
        }

        .jadcup-menu .ant-menu-submenu-title {
          display: flex;
          align-items: center;
          gap: 8px;
        }

        .jadcup-menu .anticon {
          color: #1B3B2E;
          transition: all 0.3s ease;
        }

        .jadcup-menu .ant-menu-submenu-title:hover .anticon {
          color: #8BC9A3 !important;
        }

        .ant-menu-submenu-popup {
          border-radius: 8px !important;
          box-shadow: 0 4px 16px rgba(27, 59, 46, 0.15) !important;
        }

        .ant-menu-submenu-popup .ant-menu-item:hover {
          background-color: rgba(139, 201, 163, 0.1) !important;
          color: #8BC9A3 !important;
        }

        .ant-menu-submenu-popup .ant-menu-item a:hover {
          color: #8BC9A3 !important;
        }

        /* 响应式媒体查询 */
        @media (max-width: 768px) {
          .jadcup-menu .ant-menu-submenu-title {
            padding: 0 12px !important;
          }
          
          .jadcup-menu .ant-menu-horizontal > .ant-menu-submenu > .ant-menu-submenu-title {
            padding: 0 12px;
          }
        }

        @media (max-width: 480px) {
          .jadcup-menu .ant-menu-submenu-title {
            font-size: 13px !important;
            padding: 0 8px !important;
          }
        }
      `}</style>
    </Headroom>
  )
}

export default CommonHeader